import { IoCheckmarkCircleOutline } from "react-icons/io5";
import img1 from "../../../assets/img/Industries/Energy/analytics.jpeg";
import { GoAlert } from "react-icons/go";
import { MdOutlineTimelapse } from "react-icons/md"; // For Improved Asset Lifespan
import { MdOutlineDashboard } from "react-icons/md"; // For Real-Time Dashboards

export default function MainSection5() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Predictive Analytics for Maintenance
            </h1>
            <p className="text-lg text-gray-600">
              Utilize advanced analytics to identify potential failures in
              critical infrastructure, such as turbines, transformers, and
              distribution systems, before they occur.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <GoAlert className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Proactive Equipment Monitoring
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Utilize advanced analytics to identify potential failures in
                critical infrastructure, such as turbines, transformers, and
                distribution systems, before they occur.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineTimelapse className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Improved Asset Lifespan
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Optimize maintenance schedules with predictive insights,
                reducing repair costs and extending the lifespan of energy
                assets.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineDashboard className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Real-Time Dashboards
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Provide operators with actionable insights via centralized
                dashboards, enabling faster decision-making and improved system
                performance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
